import { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useAuth } from "../Context/AuthContext";


import NewPasswordForm from "./NewPassword";
import useFetchData from "../components/useFetchDatav2";

const magnifySvgMarkup = `<svg viewBox="0 0 680 680" xmlns="http://www.w3.org/2000/svg"><defs><clipPath id="gc"><circle cx="340" cy="300" r="140"></circle></clipPath><linearGradient id="rimGrad" x1="0.15" y1="0" x2="0.85" y2="1"><stop offset="0%" stop-color="#606060"></stop><stop offset="35%" stop-color="#333333"></stop><stop offset="100%" stop-color="#0e0e0e"></stop></linearGradient><linearGradient id="handleGrad" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="#181818"></stop><stop offset="30%" stop-color="#484848"></stop><stop offset="60%" stop-color="#303030"></stop><stop offset="100%" stop-color="#0c0c0c"></stop></linearGradient><linearGradient id="lensGrad" x1="0.2" y1="0.1" x2="0.85" y2="0.9"><stop offset="0%" stop-color="#eef5fc"></stop><stop offset="55%" stop-color="#dce9f6"></stop><stop offset="100%" stop-color="#c6d8ef"></stop></linearGradient><filter id="blurText"><feGaussianBlur stdDeviation="3"></feGaussianBlur></filter></defs><rect width="680" height="680" fill="transparent"></rect><g filter="url(#blurText)" opacity="0.6"><text x="120" y="250" font-family="Georgia, serif" font-size="26" fill="#222" font-weight="bold">Rekonsil</text><text x="120" y="280" font-family="Georgia, serif" font-size="16" fill="#444">[ˌrē-kən-ˈsīl]</text><text x="120" y="315" font-family="Georgia, serif" font-size="16" fill="#333">An accounting method in</text><text x="120" y="335" font-family="Georgia, serif" font-size="16" fill="#333">which two sets of records</text><text x="120" y="355" font-family="Georgia, serif" font-size="16" fill="#333">are compared to identify</text><text x="120" y="375" font-family="Georgia, serif" font-size="16" fill="#333">any discrepancies</text><text x="120" y="395" font-family="Georgia, serif" font-size="16" fill="#333">between them.</text></g><g id="mg"><g transform="rotate(40, 340, 300)"><rect x="324" y="434" width="32" height="230" rx="16" fill="#080808"></rect><path d="M 317 427 L 317 442 Q 333 446 349 442 L 349 427 Z" fill="#555"></path></g><circle cx="340" cy="304" r="158" fill="#080808"></circle><circle cx="340" cy="300" r="158" fill="url(#rimGrad)"></circle><circle cx="340" cy="300" r="140" fill="url(#lensGrad)"></circle><circle cx="340" cy="300" r="140" fill="rgba(200,225,250,0.18)" clip-path="url(#gc)"></circle><ellipse cx="278" cy="228" rx="58" ry="20" fill="white" opacity="0.52" transform="rotate(-32,278,228)" clip-path="url(#gc)"></ellipse><ellipse cx="258" cy="214" rx="30" ry="9" fill="white" opacity="0.42" transform="rotate(-32,258,214)" clip-path="url(#gc)"></ellipse><ellipse cx="284" cy="206" rx="13" ry="5" fill="white" opacity="0.62" transform="rotate(-35,284,206)" clip-path="url(#gc)"></ellipse><circle cx="340" cy="300" r="140" fill="none" stroke="rgba(160,190,220,0.4)" stroke-width="1.5"></circle></g><g clip-path="url(#gc)" transform="translate(-5,-23)"><text x="250" y="260" font-family="Georgia, serif" font-size="30" fill="#222" font-weight="bold">Rekonsil</text><text x="250" y="285" font-family="Georgia, serif" font-size="23" fill="#444">[ˌrē-kən-ˈsīl]</text><text x="250" y="315" font-family="Georgia, serif" font-size="20" fill="#333">An accounting method in</text><text x="250" y="335" font-family="Georgia, serif" font-size="20" fill="#333">which two sets of records</text><text x="250" y="355" font-family="Georgia, serif" font-size="20" fill="#333">are compared to identify</text><text x="250" y="375" font-family="Georgia, serif" font-size="20" fill="#333">any discrepancies</text><text x="250" y="395" font-family="Georgia, serif" font-size="20" fill="#333">between them.</text></g></svg>`;

export default function Signinv3() {
   const [email, setEmail] = useState("");
   const [password, setPassword] = useState("");
   const [showPassword, setShowPassword] = useState(false);
   const {authenticate, authenticateFederated, errorMessage, challengeData } = useAuth(); // access authenticate from context

   const [msLoading, setMsLoading] = useState(false);
   const [msError, setMsError] = useState(null);

   const [verifyStatus, setVerifyStatus] = useState("idle"); // "idle" | "verifying" | "verified" | "notFound"
   const [verifyError, setVerifyError] = useState("");
   const { fetchData } = useFetchData();

   const headerRef = useRef(null);
   const logoRef = useRef(null);
   const magnifyWrapRef = useRef(null);
   const verifiedEmailRef = useRef("");
   const inFlightRef = useRef(null);
   const verifyTokenRef = useRef(0);
   const passwordInputRef = useRef(null);

   useEffect(() => {
      if (headerRef.current) {
         headerRef.current.classList.remove("card-header");
      }
   }, []); // Runs once after the initial render

   useEffect(() => {
      const paths = ["check-white", "check-green"]
         .map((id) => logoRef.current?.querySelector(`#${id}`))
         .filter(Boolean);
      const timeoutIds = [];

      paths.forEach((p) => {
         const len = p.getTotalLength();
         p.style.strokeDasharray = `${len}`;
         p.style.strokeDashoffset = `${len}`;
         p.style.transition = "stroke-dashoffset 850ms ease-out, opacity 120ms linear";
         p.classList.add("check-path");
      });

      const raf = requestAnimationFrame(() => {
         const startDelayId = setTimeout(() => {
            paths.forEach((p, i) => {
               const id = setTimeout(() => {
                  p.style.opacity = "1";
                  p.style.strokeDashoffset = "0";
               }, i * 120);
               timeoutIds.push(id);
            });
         }, 1000);
         timeoutIds.push(startDelayId);
      });

      return () => {
         cancelAnimationFrame(raf);
         timeoutIds.forEach((id) => clearTimeout(id));
      };
   }, []);

   useEffect(() => {
      let rafId = null;
      let cancelled = false;
      let animatedNode = null;

      let lastTs = null;
      let startTs = null;
      let nextSwitchAt = 0;

      let biasX = 0;
      let biasY = 0;
      let targetBiasX = 0;
      let targetBiasY = 0;

      const baseAmpX = 6.2;
      const baseAmpY = 8.8;
      const biasMaxX = 2.4;
      const biasMaxY = 3.2;
      const phaseX = Math.random() * Math.PI * 2;
      const phaseY = Math.random() * Math.PI * 2;
      const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

      const pickNextTarget = (ts) => {
         targetBiasX = clamp((Math.random() - 0.5) * (biasMaxX * 2), -biasMaxX, biasMaxX);
         targetBiasY = clamp((Math.random() - 0.5) * (biasMaxY * 2), -biasMaxY, biasMaxY);
         nextSwitchAt = ts + 1200 + Math.random() * 1200; // 1.2s..2.4s
      };

      const tick = (ts) => {
         if (cancelled || !animatedNode) return;

         if (lastTs == null) {
            lastTs = ts;
            startTs = ts;
            pickNextTarget(ts);
         }

         if (ts >= nextSwitchAt) pickNextTarget(ts);

         const dt = Math.min(64, ts - lastTs);
         lastTs = ts;
         const biasSmoothing = 1 - Math.exp(-dt / 680);

         biasX += (targetBiasX - biasX) * biasSmoothing;
         biasY += (targetBiasY - biasY) * biasSmoothing;

         const t = (ts - startTs) / 1000;
         const baseX = Math.sin(t * 0.95 + phaseX) * baseAmpX;
         const baseY = Math.sin(t * 1.25 + phaseY) * baseAmpY;
         const x = baseX + biasX;
         const y = baseY + biasY;

         animatedNode.setAttribute("transform", `translate(${x.toFixed(2)}, ${y.toFixed(2)})`);
         rafId = requestAnimationFrame(tick);
      };

      const startWhenReady = () => {
         const mg = magnifyWrapRef.current?.querySelector("#mg");
         if (!mg) {
            rafId = requestAnimationFrame(startWhenReady);
            return;
         }
         animatedNode = mg;
         rafId = requestAnimationFrame(tick);
      };

      startWhenReady();

      return () => {
         cancelled = true;
         if (rafId != null) cancelAnimationFrame(rafId);
         if (animatedNode) animatedNode.removeAttribute("transform");
      };
   }, [challengeData]);

   useEffect(() => {
      if (verifyStatus === "verified") {
         passwordInputRef.current?.focus();
      }
   }, [verifyStatus]);

   useEffect(() => () => inFlightRef.current?.abort(), []);

   const runVerify = async (candidateEmail) => {
      const trimmed = (candidateEmail || "").trim();
      if (!trimmed) return;
      if (!/\S+@\S+\.\S+/.test(trimmed)) return;
      if (trimmed === verifiedEmailRef.current && verifyStatus === "verified") return;

      inFlightRef.current?.abort();
      const controller = new AbortController();
      inFlightRef.current = controller;
      const myToken = ++verifyTokenRef.current;

      setVerifyStatus("verifying");
      setVerifyError("");

      const { responseData, fetchError } = await fetchData(
         "/verifyIdentifier.sz",
         "POST",
         { email: trimmed },
         "application/x-www-form-urlencoded",
         "json",
         controller.signal
      );

      if (myToken !== verifyTokenRef.current) return;
      if (fetchError === "Fetch aborted") return;

      const status = responseData?.status;

      if (status === 1) {
         verifiedEmailRef.current = trimmed;
         setVerifyStatus("verified");
         return;
      }

      if (status === -1) {
         setVerifyStatus("notFound");
         setVerifyError("We couldn't find an account for that email.");
         return;
      }

      // status === 0 OR fetch error — fail open (Firebase is the real auth gate)
      if (fetchError) {
         console.warn("verifyIdentifier soft-failed:", fetchError);
      } else {
         console.warn("verifyIdentifier returned unexpected status:", status);
      }
      verifiedEmailRef.current = trimmed;
      setVerifyStatus("verified");
   };

   const handleLogin = async (event) => {
      event.preventDefault();
      if (verifyStatus === "verifying") return;
      if (verifyStatus !== "verified") {
         runVerify(email);
         return;
      }
      await authenticate(email, password); // call the authenticate function from context
   };

   const handleMicrosoftLogin = async () => {
      setMsLoading(true);
      setMsError(null);
      try {
         const result = await authenticateFederated("microsoft.com");
         if (result?.st !== 1) {
             setMsError(result?.payload || "Microsoft login failed.");
         }
      } catch (err) {
         console.error("Microsoft Login Error:", err);
         if (err.code === "auth/popup-closed-by-user") {
            setMsError("Login window was closed before completion. Please try again.");
         } else {
            setMsError(err.message);
         }
      } finally {
         setMsLoading(false);
      }
   };

   const location = useLocation();
   const successMessage = location.state?.successMessage;

   return (
      <div className="page-sign d-block py-0">
         <Row className="g-0">
            <Col
               md="7"
               lg="5"
               xl="4"
               className="col-wrapper">
               {!challengeData ? (
                  <Card className="card-sign">
                     <Card.Header
                        ref={headerRef}
                        className="card-header-signin">
                        <div className="logo-wrap">
                           <svg
                              ref={logoRef}
                              id="icon"
                              xmlns="http://www.w3.org/2000/svg"
                              width="72"
                              height="72"
                              viewBox="0 1 24 24"
                              fill="none"
                              stroke="#0f1923"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round">
                              <path d="M3 10a7 7 0 1 0 14 0 7 7 0 1 0-14 0" transform="rotate(20 12 12)"></path>
                              <path
                                 id="check-white"
                                 d="m7.412 10.338 3.205 1.494 3.099-6.98"
                                 stroke="#fff"
                                 strokeWidth="4"
                                 style={{ opacity: 0 }}
                                 transform="rotate(20 12 12)"></path>
                              <path
                                 id="check-green"
                                 d="m7.412 10.338 3.205 1.494 3.099-6.98"
                                 stroke="#39b54a"
                                 strokeWidth="2.5"
                                 style={{ opacity: 0 }}
                                 transform="rotate(20 12 12)"></path>
                              <path d="M20.5 20.5 15 15" stroke="#fff" strokeWidth="4" transform="rotate(20 12 12)"></path>
                              <path d="M20.5 20.5 15 15" transform="rotate(20 12 12)"></path>
                              <path stroke="#fff" strokeWidth="4" d="m3.606 12.927 4.446 12.216" transform="rotate(20 12 12)"></path>
                              <path d="m3.606 12.927 4.446 12.216" transform="rotate(20 12 12)"></path>
                           </svg>
                        </div>
                        <Link
                           to="/"
                           className="header-logo mb-5">
                           Rekonsil
                        </Link>
                        <Card.Title>Sign In</Card.Title>
                        <Card.Text>Welcome back! Please sign in to continue.</Card.Text>
                        <p
                           className="pt-3"
                           style={{ color: "green" }}>
                           {successMessage}
                        </p>
                     </Card.Header>
                     <Card.Body>
                        <Form onSubmit={handleLogin}>
                           <div className="mb-4">
                              <Form.Label>Email address</Form.Label>
                              <Form.Control
                                 type="email"
                                 placeholder="Enter your email address"
                                 value={email}
                                 onChange={(event) => {
                                    setEmail(event.target.value);
                                    if (verifyStatus !== "idle") {
                                       inFlightRef.current?.abort();
                                       verifiedEmailRef.current = "";
                                       setVerifyStatus("idle");
                                       setVerifyError("");
                                    }
                                 }}
                              />
                              {verifyError && (
                                 <p
                                    className="pt-2"
                                    style={{ color: "red" }}>
                                    {verifyError}
                                 </p>
                              )}
                           </div>
                           {verifyStatus === "verified" && (
                              <div className="mb-4">
                                 <Form.Label className="d-flex justify-content-between">
                                    Password <Link to="/pages/forgotpassword">Forgot password?</Link>
                                 </Form.Label>
                                 <InputGroup>
                                    <Form.Control
                                       ref={passwordInputRef}
                                       type={showPassword ? "text" : "password"}
                                       placeholder="Enter your password"
                                       value={password}
                                       onChange={(event) => setPassword(event.target.value)}
                                    />
                                    <InputGroup.Text>
                                       <i onClick={() => setShowPassword(!showPassword)}>{showPassword ? <FaEyeSlash /> : <FaEye />}</i>
                                    </InputGroup.Text>
                                 </InputGroup>
                              </div>
                           )}
                           <Button
                              type="submit"
                              className="btn-sign"
                              disabled={verifyStatus === "verifying" || !email.trim()}>
                              {verifyStatus === "verifying"
                                 ? "Verifying…"
                                 : verifyStatus === "verified"
                                 ? "Sign In"
                                 : "Continue"}
                           </Button>
                           {errorMessage && (
                              <p
                                 className="pt-3"
                                 style={{ color: "red" }}>
                                 {errorMessage}
                              </p>
                           )}
                           <div className="divider">
                              <span>or sign in with</span>
                           </div>
                           <Row className="gx-2">
                              <Col>
                                 <Button
                                    variant=""
                                    style={styles.microsoftBtn}
                                    onClick={handleMicrosoftLogin}
                                    disabled={msLoading}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 21 21" style={{ marginRight: '10px', marginBottom: '2px' }}>
                                       <path fill="#f25022" d="M1 1h9v9H1z"/>
                                       <path fill="#7fba00" d="M11 1h9v9h-9z"/>
                                       <path fill="#00a4ef" d="M1 11h9v9H1z"/>
                                       <path fill="#ffb900" d="M11 11h9v9h-9z"/>
                                    </svg>
                                    {msLoading ? "Connecting..." : "Microsoft"}
                                 </Button>
                              </Col>
                          
                              {/* <Col>
                                 <Button
                                    variant=""
                                    className="btn-google">
                                    <i className="ri-google-fill"></i> Google
                                 </Button>
                              </Col>  */}
                           </Row>
                           {msError && (
                              <p className="pt-3 text-center" style={{ color: "red", fontSize: "14px" }}>{msError}</p>
                           )}
                        </Form>
                     </Card.Body>
                     <Card.Footer>{/* Don't have an account? <Link to="/signup">Create an Account</Link> */}</Card.Footer>
                  </Card>
               ) : (
                  <NewPasswordForm challengeData={challengeData} />
               )}
            </Col>
            <Col className="d-none d-lg-flex align-items-center justify-content-center">
               <div
                  ref={magnifyWrapRef}
                  className="mx-auto"
                  style={{ width: "100%", maxWidth: "620px", minHeight: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <div
                     className="w-100"
                     style={{ height: "auto", display: "flex", alignItems: "center", justifyContent: "center" }}
                     dangerouslySetInnerHTML={{ __html: magnifySvgMarkup }}
                  />
               </div>
            </Col>
         </Row>
      </div>
   );
}
const styles = {
   dividerContainer: { display: 'flex', alignItems: 'center', margin: '20px 0' },
   dividerLine: { flex: 1, border: 'none', height: '1px', backgroundColor: '#dee2e6' },
   dividerText: { padding: '0 10px', color: '#6c757d', fontSize: '13px' },
   microsoftBtn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      backgroundColor: '#fff',
      border: '1px solid #2f2f2f',
      color: '#000',
      padding: '9px',
      fontSize: '12px',
      fontWeight: '400'
   }
};